"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlamesOfTobiasAbilityHandler = exports.FlamesOfTobiasActorAbilityFactory = exports.FlamesOfTobiasAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const AbilityDamage_1 = require("../../core/AbilityDamage");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/effects/core");
const Burning_1 = require("../../core/effects/core/Burning");
const enums_1 = require("../../core/enums");
const Registries_1 = require("../../core/state/Registries");
const core_2 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
class FlamesOfTobiasAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.FlamesOfTobias;
        this.__typeName = "FlamesOfTobias";
    }
}
exports.FlamesOfTobiasAbilityArgs = FlamesOfTobiasAbilityArgs;
let FlamesOfTobiasActorAbilityFactory = class FlamesOfTobiasActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("FlamesOfTobias", "OneEnemies", 2);
    }
};
FlamesOfTobiasActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("FlamesOfTobias")
], FlamesOfTobiasActorAbilityFactory);
exports.FlamesOfTobiasActorAbilityFactory = FlamesOfTobiasActorAbilityFactory;
let FlamesOfTobiasAbilityHandler = class FlamesOfTobiasAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const invokerLevel = container.getLevel(ability.invokerId);
        const [selectedEnemy] = ability.args.target.actorIds;
        container.applyAttackWithDamage({
            sequence,
            abilityKey: ability.args.__typeName,
            attackType: "magic",
            attackerId: ability.invokerId,
            targetId: selectedEnemy,
            toApply: [
                AbilityDamage_1.AbilityDamage.Focus("Fire", 70)
            ],
            onHitOrMiss: (sequence, { hit }) => {
                sequence.push(new core_2.InstantVfxStepArgs(hit ? new LocationSelector_1.ActorVfxLocationSelector(selectedEnemy, "feet")
                    : LocationSelector_1.ActorVfxLocationSelector.Miss(selectedEnemy), "BlueFlameStrike"));
            },
            onHit(sequence) {
                container.applyDebuff({
                    sequence,
                    attackerId: ability.invokerId,
                    targetId: selectedEnemy,
                    duration: Duration_1.Duration.Turns(8),
                    effect: new core_1.LinkedEffectsEffectArgs([
                        new Burning_1.BurningEffectArgs("Focus", 10),
                        new core_1.MaxAttributeDecreaseEffectArgs(enums_1.AttributeType.FireDamageImmunity, 7),
                    ], true)
                });
            }
        });
    }
};
FlamesOfTobiasAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.FlamesOfTobias)
], FlamesOfTobiasAbilityHandler);
exports.FlamesOfTobiasAbilityHandler = FlamesOfTobiasAbilityHandler;
